import { useEffect } from "react";
import { playSfx } from "./sfx";

// Document-level dispatcher for the global SFX vocabulary. Buttons →
// click sfx, toggles + selects → quill-scratch sfx. Cards are
// intentionally silent here — call sites play the right sfx for
// inspect / mark-attacker / deck-add etc.

const BUTTON_SELECTOR = 'button,[role="button"]';

export function classifyClick(
  target: EventTarget | null,
): "button" | "other" {
  if (!(target instanceof Element)) return "other";
  if (target.closest(BUTTON_SELECTOR)) return "button";
  return "other";
}

export function classifyChange(
  target: EventTarget | null,
): "toggle" | "select" | "other" {
  if (!(target instanceof Element)) return "other";
  if (target instanceof HTMLSelectElement) return "select";
  if (target instanceof HTMLInputElement) {
    if (target.type === "checkbox" || target.type === "radio") return "toggle";
  }
  if (target.getAttribute("role") === "switch") return "toggle";
  return "other";
}

export function useEmptyClickTap() {
  useEffect(() => {
    const onClick = (ev: MouseEvent) => {
      if (classifyClick(ev.target) === "button") {
        playSfx("ai_button_click");
      }
    };
    const onChange = (ev: Event) => {
      const kind = classifyChange(ev.target);
      if (kind === "toggle" || kind === "select") {
        playSfx("ai_quill_scratch");
      }
    };
    document.addEventListener("click", onClick, true);
    document.addEventListener("change", onChange, true);
    return () => {
      document.removeEventListener("click", onClick, true);
      document.removeEventListener("change", onChange, true);
    };
  }, []);
}
